import { Unit, UnitIdAndNameOnly } from '@/types/unit';

export const unitIdAndNameOnly = (
  unit: Pick<Unit, 'id' | 'unitName'>,
): UnitIdAndNameOnly => ({ id: unit.id, unitName: unit.unitName });
